import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";

export interface iLambdaCallState {
    response: any;
    isLoading: boolean;
    message: string | null;
}

const initialState: iLambdaCallState = {
    response: null,
    isLoading: false,
    message: "",
};

// DataList API 호출
export const lambdaCallsAPI = createAsyncThunk(
    "LAMBDA_CALL",
    async (params: { lambda_name:string; group_name: string;  workflow_name :string; library_name: string; round_num: number; file_name: string, molecule_type:string ,receptor_chain:string , ligand_chain:string }, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = '/tools/function-call/';
            
            const response = await axiosInstance.post(`${djangoEndpoint}${pathParam}`, {
                lambda_name: params.lambda_name,
                group_name: params.group_name,
                library_name: params.library_name,
                workflow_name: params.workflow_name,
                round_num: params.round_num,
                file_name: params.file_name,
                molecule_type: params.molecule_type,
                receptor_chain: params.receptor_chain,
                ligand_chain: params.ligand_chain
            }, {
                withCredentials: true,
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);


// DataList Slice
export const lambdaCallSlice = createSlice({
    name: "lambdaCall",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(lambdaCallsAPI.pending, (state) => {
                state.isLoading = true;
                state.message = "";
            })
            .addCase(lambdaCallsAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload;
            })
            .addCase(lambdaCallsAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.message = action.payload as string;
            });
    },
});

export default lambdaCallSlice.reducer;